import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../auth/auth.service';
import { PermissionService } from '../auth/permission.service';
import { findArticle } from './docs.config';

/**
 * Restringe o artigo de documentação às permissões declaradas no registro
 * (`DOC_ARTICLES`), exigindo TODAS elas (`canAll`). Slug inexistente segue para o
 * componente (que mostra "não encontrado"); sem as permissões → `/acesso-negado`.
 * É apenas UX — o enforcement real dos dados vive no authorizer/backend.
 */
export const docArticleGuard: CanActivateFn = async (route) => {
  const auth = inject(AuthService);
  const permissions = inject(PermissionService);
  const router = inject(Router);

  if (!auth.user()) {
    await auth.refreshUser();
  }
  await permissions.ensureLoaded();

  const article = findArticle(route.params['slug'] as string | undefined);
  if (!article || permissions.canAll(article.permissions)) {
    return true;
  }

  return router.createUrlTree(['/acesso-negado']);
};
